<template>
  <div class="c-hero-slider">
    <v-highlight
      v-if="mainProduct"
      class="c-highlight--hero-slider"
      :product="mainProduct"
    >
      <div class="c-hero-slider__highlight-info">
        <v-play-product
          :product="mainProduct"
          :autoplay-redirect="true"
          class="o-button--icon o-button--action"
          icon-class="o-icon--play o-icon--xlarge"
        ></v-play-product>
        <div>
          <h3 class="o-typography__headline1 u-bold u-text-transform-none">
            {{ mainTitle }}
          </h3>
        </div>
      </div>
    </v-highlight>
    <v-section
      ref="section"
      show-controls-on-mobile
      :layout="TileLayout.HERO_SLIDER"
      class="c-hero-slider__slider"
      hide-first-element
    >
      <template v-for="(product, index) in $section.products">
        <ui-tile
          v-if="index"
          :key="product.id"
          :product="product"
          :layout="TileLayout.TRAILER"
          @highlight-viewport-leave="onHighlightViewportLeave"
          @trailer-ended="onTrailerEnded"
        ></ui-tile>
      </template>
      <template #headerLeft>
        <slot name="headerLeft">
          <div></div>
        </slot>
      </template>
      <template #headerRight>
        <slot name="headerRight">
          <div></div>
        </slot>
      </template>
    </v-section>
  </div>
</template>
<script>
  import { TileLayout } from '@/shared/enums';
  import { heroMainTitleMixin } from '@/index/components/section/mixins';
  import { VHighlight, VPlayProduct, VSection } from '@/index/shared/components';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
      VPlayProduct,
      VHighlight,
      VSection,
    },
    enums: {
      TileLayout,
    },
    mixins: [
      heroMainTitleMixin,
    ],
    inject: ['$section'],
    data() {
      return {
        timeout: null,
      };
    },
    computed: {
      mainProduct() {
        return this.$section && this.$section.products[0];
      },
    },
    beforeDestroy() {
      clearTimeout(this.timeout);
    },
    methods: {
      onTrailerEnded() {
        this.timeout = setTimeout(() => {
          this.$refs.section.slider.next();
          clearTimeout(this.timeout);
        }, 2000);
      },
      onHighlightViewportLeave() {
        clearTimeout(this.timeout);
      },
    },
  };
</script>
